export default {"src":"/_next/static/media/smartphone.c66cf056.svg","height":667,"width":667,"blurWidth":0,"blurHeight":0};